import {gql} from '@apollo/client';
import {PodReviewFiltersTypeInput} from './getPodReviewOrders';

export const GET_POD_REVIEW_TAB_COUNT = gql`
    query GetPodReviewTabCount($tabType: Int!, $filters: PodReviewFiltersTypeInput) {
        getPodReviewTabCount(tabType: $tabType, filters: $filters)
    }
`;

export interface GetPodReviewTabCountResponse {
    getPodReviewTabCount: number;
}

export interface GetPodReviewTabCountInput {
    tabType: number;
    filters?: PodReviewFiltersTypeInput;
}
